import type { UserRole } from '@adweb/shared';

/**
 * Coût IA remonté par n8n : réservé aux super-administrateurs. L'API ne le
 * renvoie qu'à eux ; ce test ne sert qu'à afficher ou non les colonnes.
 */
export function canSeeAiCost(role: UserRole | undefined): boolean {
  return role === 'SUPER_ADMIN';
}

/** Montant en euros ; sous 1 centime, affiche « < 0,01 € ». `digits` : décimales. */
export function formatEur(value: number | string | null | undefined, digits = 2): string {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  if (n > 0 && n < 10 ** -digits) return `< ${(10 ** -digits).toLocaleString('fr-FR')} €`;
  return n.toLocaleString('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function formatTokens(value: number | null | undefined): string {
  return value == null ? '—' : value.toLocaleString('fr-FR');
}
